import {styled, Box} from 'external/material'
import Event from './Event'
import useStudent from 'hooks/student'
import useSession from 'hooks/session'

const StyledDay = styled(Box)(dayStyles)

export default function DayView () {

  const {groups, date, eventsByDay} = useStudent()
  const dayId = date().format('YYYY-MM-DD')
  const {query} = useSession()

  const events = (eventsByDay[dayId] || [])
    .filter(event => !query.group || query.group == event.group)
    .map(event => ({
        date,
        ...event,
        group: groups.find(group => group.id == event.group)
    }))

  return (
    <StyledDay>
      <div className='schedule-events'>
        {events.map((props, i) => (<Event key={i} {...props} />))}
      </div>
    </StyledDay>
  )

}

function dayStyles() {
  return {
    overflow: 'hidden',
    padding: '0 2px 0 0',
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    color: '#69738e',
    backgroundColor: '#fff',
    border: 'solid 1px #e1eaee',
    "& .schedule-events": {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto'
    }
  } 
}
